import { ApplyOptionsFormActions } from '../reducer';

export function setCheckedGroups(dispatch, allGroups) {
  return (list) => {
    dispatch({ type: ApplyOptionsFormActions.SET_CHECK_ALL, payload: list.length === allGroups.length });
    dispatch({ type: ApplyOptionsFormActions.SET_GROUP_CHECKED, payload: list });
  };
}
